import { render, staticRenderFns } from "./SignUpSuccess.vue?vue&type=template&id=76b216b4&"
import script from "./SignUpSuccess.vue?vue&type=script&lang=js&"
export * from "./SignUpSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports